module.exports = __webpack_public_path__ + "static/media/lam-lanh-nhanh-active.ffb524c2.svg";